import { getAxiosClient } from "../../axios-client";
import {
  OfferSubcontractorAcceptRequestBody,
  OfferSubcontractorAcceptResponse,
} from "./types";

const axiosClient = getAxiosClient();
export const offerSubcontractorAccept = async (
  body: OfferSubcontractorAcceptRequestBody
) => {
  return await axiosClient.ax.post<OfferSubcontractorAcceptResponse>(
    "/Offers/OfferSubcontractorAccept",
    body
  );
};
